module.exports = __webpack_public_path__ + "img/kv-100.09189895.png";